<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <v-container fluid grid-list-xl>
      <v-layout wrap row align-center justify-centre fill-height class="mt-2 ml-1">
        <v-flex xs12 sm12 md11 lg9 xl6 offset-md0 offset-lg2 offset-xl3>
          <div :class="ui.textTitle">
            Facility Management System
          </div>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2 offset-md0 offset-lg2 offset-xl3>
          <FacilityCardDetail/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2>
          <FacilityCardUser/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2 offset-md0 offset-lg0>
          <FacilityCardAsset/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2 offset-md0 offset-lg2 offset-xl3>
          <FacilityCardOperations/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2>
          <FacilityCardMaintenance/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2 offset-md0 offset-lg0>
          <FacilityCardEngineering/>
        </v-flex>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
    </v-container>
    <AppNavigationBottom/>
</div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import FacilityCardUser from "@/frame/card/components/FacilityCardUser";
import FacilityCardOperations from "@/frame/card/components/FacilityCardOperations";
import FacilityCardMaintenance from "@/frame/card/components/FacilityCardMaintenance";
import FacilityCardEngineering from "@/frame/card/components/FacilityCardEngineering";
import FacilityCardDetail from "@/frame/card/components/FacilityCardDetail";
import FacilityCardAsset from "@/frame/card/components/FacilityCardAsset";
// import OpsCard from "@/operations/notification/components/OpsCard";
// import EngCard from "@/engineering/engineering/components/EngCard";
// import WorkCard from "@/work/request/components/WorkCard";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    FacilityCardDetail,
    FacilityCardUser,
    FacilityCardAsset,
    FacilityCardMaintenance,
    FacilityCardOperations,
    FacilityCardEngineering
    // OpsCard,
    // // WorkCard,
    // EngCard
  },
  // eslint-disable-next-line
  mixins: [
    currentPage,
    apptheme,
    storeFunctions
  ],
  created() {
    this.$store.dispatch("changeFacilityDID", this.getUser.pref.select.fdid);
    // this.clearLists();
  },
  data() {
    return {
      currentPagePath: "/facilitydash"
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser", "getCurrentPage", "getPreviousPage"]),
    AppNavigationTopInfo() {
      let obj = {
        title: "Facility",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "main",
            icon: "apps",
            link: "/appdash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      if (this.getUser.pref.select.fauth !== null) {
        obj.title = this.getUser.pref.select.fname;
      }
      return obj;
    }
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    // this.$store.dispatch("changeFacility", null);
    this.$store.dispatch("changeFacilityDID", this.getUser.pref.select.fdid);
    // DEFINE type of Document Log for future updates Read/Undear updates
    this.$store.dispatch("changeDocumentLogTag", "F1");
    // STRAT USER STORE for FACILITY ACTIONS REGISTER
    let basic = {
      did: this.getUser.pref.select.fdid,
      title: this.getUser.pref.select.fname,
      idg: this.getUser.pref.select.fdid,
      id: this.getUser.pref.select.fid,
      tag: "F1"
    };
    this.$store.dispatch("changeDetailBasic", basic);
    // RESET ASSET TREE
    this.$store.dispatch("changeTreeInfo", null);
  }
};
</script>
